import { BLOG_API_BASE_URL, AUTH_TOKEN_KEY } from 'constants/index';
import { useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { IArticleItem } from '../Helper/interface';
import { useGetViewType } from 'Pages/Home/Hooks/useGetViewType';

export default function useFetchSearchTag() {
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const [data, setData] = useState<IArticleItem[]>([]);
  const [page, setPage] = useState<number>(1);
  const [hasMore, setHasMore] = useState<boolean>(false);
  
  const { isDesktopView } = useGetViewType();

  const fetchProductByTags = async (keyword: string, resetPage?: boolean, per_page?: number) => {
    if (resetPage) {
      setPage(1);
    }
    try {
      setIsFetching(true);
      const response = await fetch(
        `${BLOG_API_BASE_URL}/articles?page=${resetPage ? 1 : page}&tags=${keyword.toLowerCase()}&per_page=${per_page ? per_page : isDesktopView ? 6 : 3}&sort_by=createdAt_desc`,
        {
          method: 'GET', // *GET, POST, PUT, DELETE, etc.
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      );
      const responseData = await response.json();
      if (responseData.error) {
        setIsFetching(false);
        setIsError(true);
        return;
      }
      
      if (resetPage) {
        setData(responseData.data.data);
        setPage(2);
      } else {
        setPage(page + 1);
        setData([...data, ...responseData.data.data]);
      }

      if (responseData.data.next_page_url) {
        setHasMore(true);
      } else {
        setHasMore(false);
      }

      setIsFetching(false);
      return responseData;
    } catch (error) {
      setIsFetching(false);
      setIsError(true);
      setError(error);
      console.log('error fetchProductByTags()', error);
      throw error;
    }
  };

  return { data, fetchProductByTags, isFetching, isError, error, page, hasMore };
}
